/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseSettingsFilter
 */
export interface DatabaseSettingsFilter {
    /**
     * 
     * @type {string}
     * @memberof DatabaseSettingsFilter
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSettingsFilter
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettingsFilter
     */
    active?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DatabaseSettingsFilter
     */
    fieldsValues?: { [key: string]: any; };
}

/**
 * Check if a given object implements the DatabaseSettingsFilter interface.
 */
export function instanceOfDatabaseSettingsFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSettingsFilterFromJSON(json: any): DatabaseSettingsFilter {
    return DatabaseSettingsFilterFromJSONTyped(json, false);
}

export function DatabaseSettingsFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSettingsFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'fieldsValues': !exists(json, 'fieldsValues') ? undefined : json['fieldsValues'],
    };
}

export function DatabaseSettingsFilterToJSON(value?: DatabaseSettingsFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'fieldsValues': value.fieldsValues,
    };
}

